import { render } from "./CustomerMessages.vue?vue&type=template&id=169cd869&scoped=true"
import script from "./CustomerMessages.vue?vue&type=script&lang=js"
export * from "./CustomerMessages.vue?vue&type=script&lang=js"

import "./CustomerMessages.vue?vue&type=style&index=0&id=169cd869&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-169cd869"]])

export default __exports__